import { Card, Button, Stack, Page, Heading } from '@shopify/polaris';
import { useState, useEffect, useContext } from 'react';
import { updateReason } from '../core/api';
import AppContext from '../AppContext';
import {API_BASE, SHOPIFY_CONTROLLER} from '../constans'

function UpdateConfirm() {
    const { shop } = useContext(AppContext);
    const [reason, setReason] = useState('');
    const [title, setTitle] = useState('');
    const [hasError, setHasError] = useState(false);

    const SHOPIFY_CONTROLLER_PATH = `${API_BASE}/${SHOPIFY_CONTROLLER}`;
    const wrongText = "Sorry, something went wrong"

    useEffect(() => {
        try {
            updateReason(shop)
                .then((updateReaason) => {
                    if (!updateReaason) 
                    {
                        setHasError(true)
                        return;
                    }
                    setReason(updateReaason.text);
                    setTitle(updateReaason.title)
                },() =>  setHasError(true));
        } catch(error) {
            setHasError(true)
            console.log("updateReason error:", error)
        }
    }, [shop]);

    return (
        <Page>
            <Card sectioned>
                <Card.Section>
                    <Heading>{hasError ? wrongText : title}</Heading>
                    {reason.split('<p>').map((line, index) => (
                        <p key={index}>{"  " + line}</p>
                    ))}
                </Card.Section>
                <Card.Section>

                    <Stack spacing="extraLoose" distribution="center">
                    <Button
                            disabled={hasError}
                            primary
                            fullWidth
                            url={`${SHOPIFY_CONTROLLER_PATH}/UpdateConfirm?shop=${shop}&isConfirm=true`}
                            external
                        >
                            Update
                        </Button>
                        <Button
                            disabled={hasError}
                            destructive
                            fullWidth
                            url={`${SHOPIFY_CONTROLLER_PATH}/UpdateConfirm?shop=${shop}&isConfirm=false`}
                            external
                        >
                            Cancel
                        </Button>
                    </Stack>
                </Card.Section>
            </Card>
        </Page>
    );
}

export default UpdateConfirm;